import React from "react";
import Slider from "react-slick";
import { SlArrowRight } from "react-icons/sl";
import { SlArrowLeft } from "react-icons/sl";


function FirstScreenSpeacers({ slider_data }) {
    const sliderRef = React.useRef(null); // Рефер на слайдер для управління стрілками

    const settings = {
        dots: false,
        arrows: false, // Вимикаємо стандартні стрілки
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: 1
    };

    return (
        slider_data ? (
            <div className="relative sm:order-1 order-2 lg:self-end z-20">
                {/* Навігаційні стрілки */}
                <div className="absolute top-1/2 transform -translate-y-1/2 sm:left-10 left-0 z-20 opacity-40 hover:opacity-100">
                    <button
                        className="p-3"
                        onClick={() => sliderRef.current.slickPrev()}
                    >
                        <SlArrowLeft className="text-3xl" />
                    </button>
                </div>
                <div className="absolute top-1/2 transform -translate-y-1/2 sm:right-10 right-0 z-20 transition-all duration-200 opacity-40 hover:opacity-100">
                    <button
                        className="p-3"
                        onClick={() => sliderRef.current.slickNext()}
                    >
                        <SlArrowRight className="text-3xl" />
                    </button>
                </div>

                <div className="gallery">
                    <div className="slider-container">
                        {/* Передаємо референс у Slider */}
                        <Slider ref={sliderRef} {...settings} className="[&_.slick-track]:flex [&_.slick-slide]:h-auto [&_.slick-slide>div]:h-full 
                            xl:-ml-8">
                            {
                                slider_data.map((item, value) => (
                                    <>
                                        {item.acf.big_image ? (
                                            <div className="relative h-full flex flex-col justify-end " key={value}>
                                                <div className="max-h-[400px] sm:max-h-[440px] flex justify-center 
                                                    xl:max-h-[640px] ">
                                                    <img src={item.acf.big_image}  alt={item.acf.speacer_name}
                                                        className="h-full "/>
                                                </div>

                                                <div className="bg-white p-6 flex flex-col items-center gap-2 text-center
                                                    xl:flex-row xl:justify-center xl:gap-8 xl:max-w-[452px] xl:absolute xl:b-0 xl:right-0">

                                                    <div className="xl:order-2">
                                                        <h3 className="font-bold uppercase text-2xl leading-none mb-2">
                                                            {item.post_title}
                                                        </h3>
                                                        <p className="font-medium leading-tight text-base">
                                                            {item.acf.position_short
                                                                ? item.acf.position_short
                                                                : item.acf.position}
                                                        </p>
                                                    </div>
                                                    {item.acf.logo ? (
                                                        <div className="flex-shrink-0 flex justify-center w-1/4 max-w-[230px] xl:order-1">
                                                            <img src={item.acf.logo} alt="logo" className="max-h-[50px]"/>
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>

                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </>
                                ))
                            }
                        </Slider>
                    </div>
                </div>
            </div>
        ) : (
            ""
        )
    );
}

export default FirstScreenSpeacers;